import React from 'react';
import PropTypes from 'prop-types';
import Heading from 'components/UI/Heading/Heading';
import Text from 'components/UI/Text/Text';
import LocationWrapper from './Location.style';
import Map from 'components/Map/Map';
import { Element } from 'react-scroll';
import { MAP_DEFAULT } from 'library/helpers/constUtils';
import { StreetMap } from './StreetMap';
import { lowerCase } from 'lodash';

const Location = ({
  
  adresse,
  codePostal,
  grandeVille,
  reperes,
  titleStyle,
  locationMetaStyle,
  contentStyle,
  boldContentStyle,
  linkStyle,
  location,
  images
}) => {
  const formattedAddress = 
  (location.grandeVille ? location.grandeVille?.trim() + ", " : "") + 
  (location.codePostal ? location.codePostal + " " : "") + 
  (location.adresse ? location.adresse : "") ;

  const isLocationGpsProvided = (location?.latitudeGps && location?.longitudeGps) ? true : false;

  const dataMap = {
    lat: isLocationGpsProvided ? +location.latitudeGps : MAP_DEFAULT.lat,
    lng: isLocationGpsProvided ? +location.longitudeGps : MAP_DEFAULT.lng,
    id: location.id,
    title: location.nom,
    formattedAddress: location.adresse,
    image : images[0]??null,
    zoom : isLocationGpsProvided ? MAP_DEFAULT.zoomWithLocation : MAP_DEFAULT.zoom,
    isLocationGpsProvided
  };

  return (
    <Element name="location" className="location">
      <LocationWrapper>
        <Heading as="h2" content="Emplacement" {...titleStyle} /><br/>
        <Text content={formattedAddress} {...locationMetaStyle} />
        {(location.accessibilites)?.length>0 
          ?<p><strong>Accessible</strong>{location.accessibilites.map((item,i) => (
            <span key={item.libelle}>{i>0?',':''}&nbsp;{lowerCase(item.libelle).replace('par ','en ').replace('a ','à ')}</span>
          )) }
          </p>
          : null
        }
        {location.reperes 
          ? location.reperes.map(item => (
            <Text
            content={item.description}
            {...contentStyle}
            {...boldContentStyle} 
          />)) 
          : null
        }

        {MAP_DEFAULT.displayGoogleMap && <Map location={dataMap} multiple={false} />}
        {MAP_DEFAULT.displayStreetMap && <StreetMap location={dataMap} />}
      </LocationWrapper>
    </Element>
  );
};

Location.propTypes = {
  titleStyle: PropTypes.object,
  locationMetaStyle: PropTypes.object,
  contentStyle: PropTypes.object,
};

Location.defaultProps = {
  titleStyle: {
    color: '#2C2C2C',
    fontSize: ['17px', '20px', '25px'],
    lineHeight: ['1.15', '1.2', '1.36'],
    mb: '4px',
  },
  locationMetaStyle: {
    fontSize: '13px',
    fontWeight: '400',
    color: '#909090',
    mb: ['14px', '20px', '27px'],
  },
  contentStyle: {
    fontSize: '15px',
    fontWeight: '400',
    color: '#2C2C2C',
    lineHeight: '1.6',
    mb: ['14px', '20px', '27px'],
  },
  boldContentStyle: {
    fontWeight: '700',
    mb: '0!important',
  },
  linkStyle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#008489',
  },
};

export default Location;
